<template>
  <div id="app">
    <div class="main-content">
      <router-view />
    </div>
    <div class="beian-footer" :class="{ 'with-tabbar': showTabbar }">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >琼ICP备2026005211号-1</a>
    </div>
    <div class="custom-tabbar" v-if="showTabbar">
      <div class="tabbar-bg"></div>
      <div class="tabbar-content">
        <router-link 
          v-for="(item, index) in tabbarItems" 
          :key="item.path"
          :to="item.path"
          class="tabbar-item"
          :class="{ 'active': activeTab === index }"
          @click="activeTab = index"
        >
          <div class="tabbar-icon-wrap">
            <van-icon :name="activeTab === index ? item.activeIcon : item.icon" size="24" />
            <div class="icon-glow" v-if="activeTab === index"></div>
          </div>
          <span class="tabbar-text">{{ item.text }}</span>
          <div class="active-indicator" v-if="activeTab === index"></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeTab: 0,
      tabbarItems: [
        { path: '/home', text: '首页', icon: 'home-o', activeIcon: 'home-o' },
        { path: '/quiz', text: '答题', icon: 'question-o', activeIcon: 'question-o' },
        { path: '/vip', text: 'VIP', icon: 'gem-o', activeIcon: 'gem' },
        { path: '/profile', text: '我的', icon: 'user-o', activeIcon: 'user-o' }
      ]
    }
  },
  computed: {
    showTabbar() {
      if (this.$route.meta && this.$route.meta.hideTabbar) {
        return false
      }
      const hiddenRoutes = ['/result', '/login']
      if (hiddenRoutes.includes(this.$route.path)) {
        return false
      }
      if (this.$route.path === '/quiz' && this.$store.state.quizHideTabbar) {
        return false
      }
      return true
    }
  },
  watch: {
    '$route'(to) {
      this.updateActiveTab(to.path)
    }
  },
  mounted() {
    this.updateActiveTab(this.$route.path)
  },
  methods: {
    updateActiveTab(path) {
      const tabMap = {
        '/home': 0,
        '/quiz': 1,
        '/vip': 2,
        '/profile': 3
      }
      this.activeTab = tabMap[path] || 0
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

html, body {
  width: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

html {
  font-size: calc(100vw / 375 * 14px);
}

@media screen and (min-width: 414px) {
  html {
    font-size: calc(100vw / 414 * 14px);
  }
}

@media screen and (max-width: 320px) {
  html {
    font-size: 12px;
  }
}

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

input, textarea, button {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  border: none;
  font-family: inherit;
}

input:focus, textarea:focus {
  outline: none;
}

button {
  cursor: pointer;
}

a {
  text-decoration: none;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

.beian-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  text-align: center;
  padding: 8px 12px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
  pointer-events: none;
}

.beian-footer.with-tabbar {
  bottom: calc(70px + env(safe-area-inset-bottom));
  padding-bottom: 8px;
}

.beian-footer a {
  pointer-events: auto;
  display: inline-block;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
}

.beian-footer.with-tabbar a {
  color: #999;
}

.custom-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: auto;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 999;
}

.tabbar-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  box-shadow: 0 -4px 20px rgba(102, 126, 234, 0.15);
}

.tabbar-bg::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.2), transparent);
}

.tabbar-content {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 8px 0;
  position: relative;
  z-index: 1;
}

.tabbar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  position: relative;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.tabbar-item:active {
  transform: scale(0.92);
}

.tabbar-icon-wrap {
  position: relative;
  width: 44px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabbar-icon-wrap .van-icon {
  color: #999;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.tabbar-item.active .tabbar-icon-wrap .van-icon {
  color: #764ba2;
  transform: scale(1.15);
}

.icon-glow {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 4px;
  background: radial-gradient(ellipse, rgba(102, 126, 234, 0.4), transparent);
  border-radius: 50%;
  animation: icon-glow-pulse 2s ease-in-out infinite;
}

@keyframes icon-glow-pulse {
  0%, 100% { opacity: 0.6; transform: translateX(-50%) scale(1); }
  50% { opacity: 1; transform: translateX(-50%) scale(1.2); }
}

.tabbar-text {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 500;
}

.tabbar-item.active .tabbar-text {
  color: #764ba2;
  font-weight: 600;
}

.active-indicator {
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  animation: indicator-bounce 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes indicator-bounce {
  0% { transform: translateX(-50%) scale(0); }
  50% { transform: translateX(-50%) scale(1.5); }
  100% { transform: translateX(-50%) scale(1); }
}
</style>